/*
  GEN78 — dinamik lookbook: grid karosuna tıklayınca açılan tam ekran look modalı

  Neden var: eski lookbook'ta her look ayrı bir Shopify sayfasıydı; look'a tıklamak
  tam sayfa yenilemesi demekti ve look'lar arasında gezinme yoktu. Burada tüm
  look'lar tek sayfada duruyor, modal içinde ileri/geri gezinilebiliyor.

  Neden içerik istemcide üretiliyor: canlı sayfada ölçüldü — tema
  product-card-mini'yi kart başına ~3.6 KB HTML olarak basıyor (geniş srcset
  yüzünden). 38 look x 4 ürün = ~550 KB fazladan HTML demekti. Bunun yerine
  section kompakt bir JSON basıyor (gzip sonrası ~7 KB), kartlar burada üretiliyor.
  Grid görselleri sunucuda basılmaya devam ediyor — SEO ve ilk boyama etkilenmiyor.

  YSL referansından alınan davranışlar (kaynak koddan doğrulandı):
  * yalnızca aktif ve komşu look'ların içeriği üretilir (shouldLoadProductsTile)
  * slaytlar çapraz geçişle (crossfade) değişir
  * ilk look'ta geri, son look'ta ileri butonu pasif (disabled)
  * slayt değişince adres çubuğu güncellenir (paylaşılabilir bağlantı)

  theme.js'e dokunulmuyor — entegrasyon tamamen DOM üzerinden.
*/
(function () {
  'use strict';

  var SELECTORS = {
    root: '[data-gen78-lookbook]',
    data: '[data-gen78-lookbook-data]',
    tile: '[data-look-open]',
    modal: '[data-gen78-look-modal]',
    slides: '[data-look-slides]',
    products: '[data-look-products]',
    counter: '[data-look-counter]',
    prev: '[data-look-prev]',
    next: '[data-look-next]',
    close: '[data-look-close]'
  };

  var CLASSES = {
    open: 'is-open',
    active: 'is-active',
    scrollLock: 'gen78-look-modal-open'
  };

  var FOCUSABLE =
    'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';

  var SWIPE_THRESHOLD = 40;

  /* ------------------------------------------------------------ yardımcı -- */

  /*
    Görsel URL'leri Liquid tarafında hazır üretilip JSON'a yazılıyor (src + srcset).
    Burada URL kurmuyoruz: image_url filtresi width/height olmadan hata veriyor,
    dolayısıyla URL'i istemcide parçalayıp yeniden kurmak kırılgan olurdu.
  */

  function el(tag, className) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    return node;
  }

  /* -------------------------------------------------------------- bileşen - */

  function Lookbook(root) {
    this.root = root;
    this.modal = root.querySelector(SELECTORS.modal);

    var dataNode = root.querySelector(SELECTORS.data);
    if (!this.modal || !dataNode) return;

    try {
      this.looks = JSON.parse(dataNode.textContent).looks || [];
    } catch (e) {
      // Bozuk JSON tüm sayfayı düşürmesin — lookbook sessizce grid olarak kalır.
      this.looks = [];
    }
    if (!this.looks.length) return;

    this.slidesEl = this.modal.querySelector(SELECTORS.slides);
    this.counterEl = this.modal.querySelector(SELECTORS.counter);
    this.prevEl = this.modal.querySelector(SELECTORS.prev);
    this.nextEl = this.modal.querySelector(SELECTORS.next);

    this.index = -1;
    this.lastFocus = null;
    this.slideNodes = [];
    this.built = {};
    this.touchX = null;

    this.bind();
    this.openFromUrl();
  }

  Lookbook.prototype.bind = function () {
    var self = this;

    this.root.addEventListener('click', function (event) {
      var tile = event.target.closest(SELECTORS.tile);
      if (!tile || !self.root.contains(tile)) return;
      event.preventDefault();
      self.open(parseInt(tile.getAttribute('data-look-index'), 10), tile);
    });

    this.modal.addEventListener('click', function (event) {
      if (event.target.closest(SELECTORS.close)) {
        event.preventDefault();
        self.close();
        return;
      }
      if (event.target.closest(SELECTORS.prev)) {
        event.preventDefault();
        self.go(self.index - 1);
        return;
      }
      if (event.target.closest(SELECTORS.next)) {
        event.preventDefault();
        self.go(self.index + 1);
      }
    });

    // Klavye yalnızca modal açıkken dinleniyor.
    this.onKeydown = function (event) {
      if (!self.isOpen()) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        self.close();
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        self.go(self.index - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        self.go(self.index + 1);
      } else if (event.key === 'Tab') {
        self.trapFocus(event);
      }
    };
    document.addEventListener('keydown', this.onKeydown);

    this.modal.addEventListener(
      'touchstart',
      function (event) {
        self.touchX = event.changedTouches[0].clientX;
      },
      { passive: true }
    );

    this.modal.addEventListener(
      'touchend',
      function (event) {
        if (self.touchX === null) return;
        // Ürün şeridi yatay kaydırılırken slayt değiştirmeyelim.
        if (event.target.closest(SELECTORS.products)) {
          self.touchX = null;
          return;
        }
        var delta = event.changedTouches[0].clientX - self.touchX;
        self.touchX = null;
        if (Math.abs(delta) < SWIPE_THRESHOLD) return;
        self.go(delta < 0 ? self.index + 1 : self.index - 1);
      },
      { passive: true }
    );
  };

  Lookbook.prototype.isOpen = function () {
    return this.modal.classList.contains(CLASSES.open);
  };

  /* ------------------------------------------------------- slayt üretimi -- */

  // Slayt kabuğu bir kez üretilir; içerik (görsel + ürünler) ilk gösterimde dolar.
  Lookbook.prototype.slideNode = function (i) {
    if (this.slideNodes[i]) return this.slideNodes[i];

    var slide = el('div', 'gen78-look-slide');
    slide.setAttribute('data-look-slide', String(i));
    slide.setAttribute('aria-hidden', 'true');

    var figure = el('figure', 'gen78-look-slide__figure');
    slide.appendChild(figure);

    this.slidesEl.appendChild(slide);
    this.slideNodes[i] = slide;
    return slide;
  };

  Lookbook.prototype.build = function (i) {
    if (i < 0 || i >= this.looks.length || this.built[i]) return;

    var look = this.looks[i];
    var slide = this.slideNode(i);
    var figure = slide.querySelector('.gen78-look-slide__figure');

    if (look.img && look.img.s) {
      var img = el('img');
      img.src = look.img.s;
      if (look.img.ss) {
        img.srcset = look.img.ss;
        img.sizes = '(min-width: 768px) 70vw, 100vw';
      }
      img.alt = look.img.a || '';
      img.loading = 'lazy';
      img.decoding = 'async';
      if (look.img.w) img.width = look.img.w;
      if (look.img.h) img.height = look.img.h;
      figure.appendChild(img);
    }

    this.built[i] = true;
  };

  Lookbook.prototype.productsHtml = function (i) {
    var look = this.looks[i];
    var host = this.modal.querySelector(SELECTORS.products);
    if (!host) return;

    host.textContent = '';

    /*
      Look numarası şeridin üstünde (müşteri revizesi 29.08.26, 2B:
      "diyorum ki buraya da böyle look numarası gelsün, ürünler altına
      gelsin"). Yalnızca dikey düzende (mobil/tablet) görünüyor — masaüstünde
      ürünler görselin YANINDA durduğu için hangi look olduğu zaten belli,
      etiketi CSS gizliyor.

      Etiket sunucudan geliyor (look.l): "LOOK" öneki section ayarı
      (caption_prefix), istemcide uydurulamaz.
    */
    if (look && look.l) {
      var number = el('div', 'gen78-look-modal__number');
      number.textContent = look.l;
      host.appendChild(number);
    }

    var items = (look && look.products) || [];
    if (!items.length) return;

    var list = el('ul', 'gen78-look-products');

    items.forEach(function (product) {
      var li = el('li', 'gen78-look-products__item');
      var link = el('a', 'gen78-look-product');
      link.href = product.u || '#';

      var imgWrap = el('div', 'gen78-look-product__image');
      if (product.i) {
        var img = el('img');
        // Kart en fazla 152 CSS px; 400w tek URL yüksek DPR'yi de karşılıyor,
        // srcset eklemek payload'ı ürün başına ~95 bayt şişirirdi.
        img.src = product.i;
        img.alt = product.t || '';
        img.loading = 'lazy';
        img.decoding = 'async';
        imgWrap.appendChild(img);
      }
      link.appendChild(imgWrap);

      var title = el('div', 'gen78-look-product__title fs-body-75');
      title.textContent = product.t || '';
      link.appendChild(title);

      if (product.av === false) {
        var soldOut = el('div', 'gen78-look-product__sold-out fs-body-75');
        soldOut.textContent = host.getAttribute('data-sold-out-label') || '';
        link.appendChild(soldOut);
      } else if (product.p) {
        var price = el('div', 'gen78-look-product__price fs-body-75');
        // İndirimli fiyat varsa eski fiyat üstü çizili gösterilir.
        if (product.cp) {
          var was = el('del');
          was.textContent = product.cp;
          price.appendChild(was);
        }
        price.appendChild(document.createTextNode(product.p));
        link.appendChild(price);
      }

      li.appendChild(link);
      list.appendChild(li);
    });

    host.appendChild(list);
  };

  /* ------------------------------------------------------------- gezinme -- */

  Lookbook.prototype.go = function (i) {
    if (i < 0 || i >= this.looks.length || i === this.index) return;

    // YSL'deki gibi aktif + komşu look'lar hazır tutuluyor.
    this.build(i - 1);
    this.build(i);
    this.build(i + 1);

    this.slideNodes.forEach(function (node, idx) {
      if (!node) return;
      var isActive = idx === i;
      node.classList.toggle(CLASSES.active, isActive);
      node.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });

    this.index = i;
    this.productsHtml(i);
    this.updateChrome();
    this.syncUrl();
  };

  Lookbook.prototype.updateChrome = function () {
    var total = this.looks.length;
    var look = this.looks[this.index] || {};

    if (this.counterEl) {
      // Toplam da look numaraları gibi iki haneye tamamlanıyor ("02 / 04"),
      // aksi hâlde "02 / 4" gibi tutarsız görünüyordu.
      var totalLabel = total < 10 ? '0' + total : String(total);
      var template = this.counterEl.getAttribute('data-template') || '{{current}} / {{total}}';
      this.counterEl.textContent = template
        .replace('{{current}}', look.n || String(this.index + 1))
        .replace('{{total}}', totalLabel);
    }

    if (this.prevEl) this.prevEl.disabled = this.index <= 0;
    if (this.nextEl) this.nextEl.disabled = this.index >= total - 1;
  };

  /*
    Paylaşılabilir bağlantı: ?look=3 (YSL de sorgu parametresi kullanıyor).
    Hash yerine sorgu parametresi tercih edildi — kopyalanan bağlantı e-posta,
    mesajlaşma ve sosyal medyada hash'ten daha güvenilir taşınıyor ve sunucuya
    ulaştığı için ileride gerekirse sunucu tarafında da okunabilir.
    history yığınını şişirmemek için replaceState.
  */
  Lookbook.prototype.syncUrl = function () {
    if (!window.history || !window.history.replaceState) return;
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('look', String(this.index + 1));
      window.history.replaceState(null, '', url.pathname + url.search);
    } catch (e) {
      /* URL desteklenmiyorsa adres çubuğu güncellenmez — modal yine çalışır. */
    }
  };

  Lookbook.prototype.clearUrl = function () {
    if (!window.history || !window.history.replaceState) return;
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete('look');
      window.history.replaceState(null, '', url.pathname + url.search);
    } catch (e) {}
  };

  /* --------------------------------------------------------- aç / kapat --- */

  Lookbook.prototype.open = function (i, trigger) {
    if (isNaN(i)) return;

    this.lastFocus = trigger || document.activeElement;
    this.modal.classList.add(CLASSES.open);
    this.modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add(CLASSES.scrollLock);

    this.go(i);

    var focusTarget = this.modal.querySelector(SELECTORS.close);
    if (focusTarget) focusTarget.focus();
  };

  Lookbook.prototype.close = function () {
    this.modal.classList.remove(CLASSES.open);
    this.modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove(CLASSES.scrollLock);
    this.clearUrl();

    // Odak tıklanan karoya dönmeli — klavye kullanıcısı yerini kaybetmesin.
    if (this.lastFocus && document.contains(this.lastFocus)) {
      this.lastFocus.focus();
    }
    this.lastFocus = null;
  };

  Lookbook.prototype.trapFocus = function (event) {
    var nodes = Array.prototype.slice
      .call(this.modal.querySelectorAll(FOCUSABLE))
      .filter(function (node) {
        return !node.disabled && node.offsetParent !== null;
      });
    if (!nodes.length) return;

    var first = nodes[0];
    var last = nodes[nodes.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  // Sayfa ?look=3 ile açıldıysa doğrudan o look'u göster.
  // #look-3 de destekleniyor: bu biçimde paylaşılmış eski bağlantılar bozulmasın.
  Lookbook.prototype.openFromUrl = function () {
    var n = null;
    try {
      var q = new URL(window.location.href).searchParams.get('look');
      if (q) n = parseInt(q, 10);
    } catch (e) {}

    if (n === null || isNaN(n)) {
      var m = /^#look-(\d+)$/.exec(window.location.hash || '');
      n = m ? parseInt(m[1], 10) : null;
    }
    if (n === null || isNaN(n)) return;

    var i = n - 1;
    if (i >= 0 && i < this.looks.length) this.open(i, null);
  };

  /* ---------------------------------------------------------------- init -- */

  function init() {
    document.querySelectorAll(SELECTORS.root).forEach(function (root) {
      if (root.gen78Lookbook) return;
      root.gen78Lookbook = new Lookbook(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Tema düzenleyicisinde section yeniden yüklendiğinde tekrar bağlan.
  document.addEventListener('shopify:section:load', init);
})();
